<template>
  <div style="width: 100%" ref="contentContainer">
    <p
      class="article-content-snapshot"
      @click="doubleClickWord"
      v-html="content"
      ref="contentContainer"
    ></p>
    <ShengciAlert
      :wordInfo="newWord.wordInfo"
      :contentId="contentId"
      :showNewWord="newWord.showNewWord"
      :x="newWord.x"
      :y="newWord.y"
      @changelBlock="action_cancelLookNewword()"
    />
  </div>
</template>

<script>
import _ from "lodash";
import ShengciAlert from "@/components/shengCiAlert/ShengciAlert";
import { postWord } from "@/api/vocab";
import { mapState } from "vuex";

export default {
  name: "ArticleContent",
  props: {
    content: {
      type: String,
      default: "",
    },
    showVocab: {
      type: Boolean,
      default: false,
    }

  },
  data() {
    return {
      newWord: {
        //生词
        showNewWord: false,
        x: 100,
        y: 100,
        event: null,
        wordInfo: {}, //翻译后的单词
      },
    };
  },
  components: {
    ShengciAlert,
  },
  watch: {
    content(val) {
      let imgs = this.$refs.contentContainer.getElementsByTagName("img");
      _.map(imgs, (img) => {
        img.style.borderRadius = "10px";
      });
    },
  },
  computed: {
    ...mapState({
      words: (state) => state.article.words,
      articleDetail: (state) => state.article.articleDetail,
      contentId: (state) => state.article.contentId,
      levels: (state) => state.article.levels,
      articleContent: (state) => state.article.articleContent,
      wordBook: (state) => state.article.wordBook,
    }),
  },
  mounted() {
    HTMLCollection.prototype[Symbol.iterator] =
      Array.prototype[Symbol.iterator];

    let imgs = this.$refs.contentContainer.getElementsByTagName("img");
    _.map(imgs, (img) => {
      // console.log(img.style)
      img.style.borderRadius = "10px";
    });
  },
  methods: {
    doubleClickWord(event) {
      if(!this.showVocab){
        return
      }
      console.log(event.target.className); // testssss
      console.log(event.target.nodeName); // SPAN
      console.log(event);
      if (
        event.target.nodeName === "SPAN" &&
        event.target.className === "word"
      ) {
        const selWord = event.target.outerText;
        if (selWord) {
          if (selWord.match(/^[A-Za-z]+$/)) {
            this.request_wordExplain(selWord, event);
          }
        } else {
          this.$toast("不好意思,未取到单词");
        }
      }
    },
    //取消查看单词
    action_cancelLookNewword(value) {
      this.newWord.event.target.style.backgroundColor = "#fff";
      this.newWord.event.target.style.color = "rgb(51, 51, 51)";
      this.newWord.showNewWord = value;
    },
    request_wordExplain(word, event) {
      let params = {
        contentId: this.contentId,
        wordName: word,
      };
      postWord(params).then((result) => {
        if (result.code === 0) {
          this.newWord.wordInfo = result.data;

          this.newWord.event = event;

          //获取滚动距离
          var scrollTop =
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0;

          //选中元素中间点相对于视口的位置
          const selElX =
            event.target.offsetLeft + event.target.offsetWidth * 0.5;
          const selElY =
            event.target.offsetTop +
            event.target.offsetHeight * 0.5 -
            scrollTop;

          //展示位置
          this.newWord.x = selElX;
          this.newWord.y = selElY;

          event.target.style.backgroundColor = "#0087f6";
          event.target.style.color = "#fff";

          //弹窗翻译该单词
          this.newWord.showNewWord = true;
        }
      });
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.article-content-snapshot {
  padding-bottom: 10px;
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// app/components/content/ArticleContent.vue